module.exports = __webpack_public_path__ + "media/src/website/images/locations/felden/felden_05-5b225019437716e36f5e4540c7f3a097.jpg";